import { Tooltip } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { ReactComponent as HeadsetIcon } from "./assets/headset.svg";

export const VoiceTransferredCallBadge: React.FC = () => {
  const { t } = useTranslations();

  return (
    <Tooltip
      renderTrigger={({ ref, props }) => (
        <div
          ref={ref}
          {...props}
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-[#FFE8FB] ring-1 ring-white transition ring-inset hover:ring-dark-700"
        >
          <HeadsetIcon />
        </div>
      )}
    >
      {t({
        id: "client-support-page.transferred-call",
        defaultMessage: "Transferred Call",
      })}
    </Tooltip>
  );
};
